import Vue from 'vue'
import { apolloClient } from '@/apollo'
import gql from 'graphql-tag'

export const fetchItemsQuery = gql`
  query SearchItems {
    item(order_by: {created_at: asc}) {
      id
      name
      created_at
    }
  }
`

export const softDeleteItemsMutation = gql`
  mutation SoftDeleteItems($catalog_id: uuid!, $data: item_set_input!) {
    update_item(where: {catalog_id: {_eq: $catalog_id}}, _set: $data) {
      affected_rows
    }
  }
`

export const ActivateItemsMutation = gql`
  mutation ActivateItems($catalog_id: uuid!, $data: item_set_input!) {
    update_item(where: {catalog_id: {_eq: $catalog_id}}, _set: $data) {
      affected_rows
    }
  }
`

const item = {
  namespaced: true,
  state: {
    items: []
  },
  actions: {
    async fetchAll ({ commit }) {
      try {
        const requestQuery = {
          query: fetchItemsQuery
        }

        const result = await apolloClient.query(requestQuery)
        if (result && result.data) {
          commit('SET_ITEMS', result.data.item)
        }
      } catch (err) {
        window.console.error(err)
      }
    },
    async softDeleteItems ({ commit }, catalogId) {
      try {
        const insertMutation = {
          mutation: softDeleteItemsMutation,
          variables: {
            catalog_id: catalogId,
            data: {
              deleted_at: new Date().toISOString()
            }
          }
        }

        const result = await apolloClient.mutate(insertMutation)
        if (result && result.data && result.data.update_item.affected_rows >= 1) {
          commit('SET_ITEMS', result.data.update_item.returning)
        }

        return result
      } catch (error) {
        window.console.error(error)
        throw new Error(error)
      }
    },
    async activateItems ({ commit }, catalogId) {
      try {
        const insertMutation = {
          mutation: ActivateItemsMutation,
          variables: {
            catalog_id: catalogId,
            data: {
              is_active: true,
              published_at: new Date().toISOString()
            }
          }
        }

        const result = await apolloClient.mutate(insertMutation)
        if (result && result.data && result.data.update_item.affected_rows >= 1) {
          commit('SET_ITEMS', result.data.update_item.returning)
        }

        return result
      } catch (error) {
        window.console.error(error)
        throw new Error(error)
      }
    }
  },
  mutations: {
    SET_ITEMS (state, data) {
      Vue.set(state, 'items', data)
    }
  },
  getters: {
    itemsInfo: state => state.items
  }
}

export default item



// WEBPACK FOOTER //
// ./src/store/modules/item.js